import { Box } from "@mui/material";
import React from "react";
import {
  allowedToDeleteEntity,
  allowedToReadEntity,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { contextColumns as columns } from "../../Helper";
import { isOpenPopup } from "src/utils/isOpenPopup";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { path } from "src/constants/path";

const GetContextColumns = ({ handleDelete, handleOpenPopup, status }) => {
  const { auth } = useAuth();
  const history = useHistory();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const showDetailContext = (context) => {
    history.push(`${path.flfContext}/${context.id}`);
  };
  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToReadEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-success"
            onClick={() => {
              showDetailContext(item);
            }}
          >
            <i className="bx bx-show"></i>
          </button>
        )}
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-warning"
            onClick={() => {
              handleOpenPopup(isOpenPopup, item);
            }}
          >
            <i className="bx bx-edit"></i>
          </button>
        )}
        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <button className="btn btn-danger" onClick={() => handleDelete(item)}>
            <i className="bx bx-trash"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetContextColumns;
